
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { getOperatorTitle, getValidOperators } from '../../functions/query'
import { ListFilter } from './favourites'

type FilterOption = {
  text: string;
  value: string | number;
}

export type ListFilterOption = {
  text: string;
  key: string;
  type: string;
  options?: FilterOption[]
}

@Component
export default class FiltersComponent extends Vue {
  @Prop({ type: Array, required: true })
  private readonly filterOptions!: ListFilterOption[]

  @Prop({ type: Array, required: true })
  private readonly activeFilters!: ListFilter[]

  private newFilter: Partial<ListFilter> = {}

  private showAdd = false

  private date: Date | null = null

  private showDatepicker = false

  private get validValue() {
    if (!this.newFilter) {
      return false
    }

    const invalidValues: (string | null | undefined)[] = [null, undefined]
    return !invalidValues.includes(this.newFilter?.value)
  }

  validOperators(key?: string) {
    const filterType = this.filterOptions.find(f => f.key === key)?.type || ''
    return getValidOperators(filterType)
  }

  filterType(key?: string) {
    return this.filterOptions.find(f => f.key === key)?.type
  }

  isEnum(key?: string) {
    const filterType = this.filterOptions.find(f => f.key === key)?.type
    if (!filterType) {
      return false
    }
    return ['enum', 'boolean'].includes(filterType)
  }

  exitAdd() {
    this.newFilter = {}
    this.showAdd = false
    this.date = null
    this.showDatepicker = false
  }

  addFilter() {
    const fieldName = this.filterOptions.find(f => f.key === this.newFilter.field)?.text
    const operatorName = getOperatorTitle(this.newFilter?.operator || '')

    let displayValue = this.newFilter?.displayValue

    if (this.isEnum(this.newFilter?.field)) {
      const options = this.getEnumOptions(this.newFilter?.field || '')
      displayValue = options.find(i => i.value === this.newFilter?.value)?.text
    }

    this.newFilter.text = `'${fieldName}' ${operatorName} '${displayValue || this.newFilter?.value}'`
    this.newFilter.disabled = false

    this.$emit('addfilter', { ...this.newFilter })
    this.exitAdd()
  }

  toggleFilterDisabled(filter: ListFilter) {
    this.$emit('filterstatus', filter)
    this.$nextTick().then(() => { this.$forceUpdate() })
  }

  removeFilter(filter: ListFilter) {
    this.$emit('removefilter', filter)
  }

  updateDateValue(dateString: string) {
    const date = new Date(dateString)
    this.newFilter.value = date.toISOString()
    this.newFilter.displayValue = date.toLocaleDateString()
    this.showDatepicker = false
    this.$forceUpdate()
  }

  getEnumOptions(field?: string): FilterOption[] {
    const filter = this.filterOptions.find(f => f.key === field)
    if (filter?.type === 'boolean') {
      return [
        { text: 'Yes', value: 1 },
        { text: 'No', value: 0 }
      ]
    }
    return filter?.options || []
  }
}
